import { useContext } from 'react'
import { ShopByBrandThumbnail } from '../shop-by-brand-thumbnail/shop-by-brand-thumbnail'
import styles from './brands-list.module.css'
import { SharedUiHeaderV2Context } from '../../context/context-shared-ui-header-v2'
import { parentLinks } from '../../../data/parent-menu'
import { BrandCard } from '../../../data/shared'

interface BrandsListProps {
  brandsList: BrandCard[]
}

export const BrandsList = ({ brandsList }: BrandsListProps) => {
  const { logicStore } = useContext(SharedUiHeaderV2Context)

  const { handleTrackEvent } = logicStore

  return (
    <div className={styles.shopByBrandContainer}>
      {brandsList.map((brand) => (
        <ShopByBrandThumbnail
          key={brand.href?.slice(1) ?? brand.label?.replace(/\s/g, '')}
          title={brand.label}
          href={brand.href}
          image={brand.image}
          alt={brand.alt}
          handleTrackEvent={() =>
            handleTrackEvent({
              name: 'click',
              category: 'mega menu',
              label: parentLinks.NEWCARS,
              action: 'shop by type',
              value: brand.label,
            })
          }
        />
      ))}
    </div>
  )
}
